"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EChartPeriod = void 0;
var EChartPeriod;
(function (EChartPeriod) {
    EChartPeriod["MINUTE_1"] = "PERIOD_M1";
    EChartPeriod["MINUTE_2"] = "PERIOD_M2";
    EChartPeriod["MINUTE_3"] = "PERIOD_M3";
    EChartPeriod["MINUTE_4"] = "PERIOD_M4";
    EChartPeriod["MINUTE_5"] = "PERIOD_M5";
    EChartPeriod["MINUTE_6"] = "PERIOD_M6";
    EChartPeriod["MINUTE_10"] = "PERIOD_M10";
    EChartPeriod["MINUTE_15"] = "PERIOD_M15";
    EChartPeriod["MINUTE_20"] = "PERIOD_M20";
    EChartPeriod["MINUTE_30"] = "PERIOD_M30";
    EChartPeriod["HOUR_1"] = "PERIOD_H1";
    EChartPeriod["HOUR_2"] = "PERIOD_H2";
    EChartPeriod["HOUR_3"] = "PERIOD_H3";
    EChartPeriod["HOUR_4"] = "PERIOD_H4";
    EChartPeriod["HOUR_6"] = "PERIOD_H6";
    EChartPeriod["DAY"] = "PERIOD_D1";
    EChartPeriod["WEEK"] = "PERIOD_W1";
    EChartPeriod["MONTH"] = "PERIOD_MN1";
})(EChartPeriod = exports.EChartPeriod || (exports.EChartPeriod = {}));
